// @ts-nocheck
import LoadingSpinner from "components/LoadingSpinner";
import PopupVideo from "components/popup-video";
import { CAMPAIGNID } from "constants/common";
import React, { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "redux/prize/actions";
import PrizeView from "./view";
import { sha256 } from "js-sha256";
import $ from "jquery";

const PrizePage = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [modalVideo, setModalVideo] = useState(false);
  const [remaining, setRemaining] = useState({});
  const [listWinnerSpecial, setListWinnerSpecial] = useState([]);
  const [listWinnerSecond, setListWinnerSecond] = useState([]);
  const [listWinnerThree, setListWinnerThree] = useState([]);
  const [listPhaseSpecial, setListPhaseSpecial] = useState(
    Array.from(Array(13).keys())
  );
  const [listPhaseSecond, setListPhaseSecond] = useState(
    Array.from(Array(13).keys())
  );

  const [listPhaseThree, setListPhaseThree] = useState(
    Array.from(Array(13).keys())
  );
  const [listPicture, setListPicture] = useState([]);
  const listWinnerSpecialOrigin = useRef([]);
  const listWinnerSecondOrigin = useRef([]);
  const listWinnerThreeOrigin = useRef([]);


  const [listWinnerSpeciaSwiper, setListWinnerSpeciaSwiper] = useState([]);

  const [pages, setPages] = useState(0);
  const [pagesSpecial, setPagesSpecial] = useState(0);
  const [pagesSecond, setPagesSecond] = useState(0);
  const [pagesThree, setPagesThree] = useState(0);

  const [prizeTypeSpecial, setPrizeTypeSpecial] = useState(0);
  const [prizeTypeSecond, setPrizeTypeSecond] = useState(0);

  const [searchCode, setSearchCode] = useState("");
  const [searchCodeSpecial, setSearchCodeSpecial] = useState("");
  const [searchCodeSecond, setSearchCodeSecond] = useState("");
  const searchCodeSecondRef = useRef("");
  const searchCodeSpecialRef = useRef("");

  const [searchCodeTemp, setSearchCodeTemp] = useState("");
  const [pageOffset, setPageOffset] = useState(0);

  const [pageOffsetSpecial, setPageOffsetSpecial] = useState(0);
  const [pageOffsetSecond, setPageOffsetSecond] = useState(0);
  const prizeTypeSpecialRef = useRef(0);
  const prizeTypeSecondlRef = useRef(0);

  const prizeTypes = [
    { label: 'Tất cả', value: '' },
    { label: 'Giải Nhất', value: 1 },
    { label: 'Giải Nhì', value: 2 },
    { label: 'Giải Ba', value: 3 },
    { label: 'Giải Khuyến Khích', value: 4 },
  ];
  
  const [prizeTypeSelected, setPrizeTypeSelected] = useState(prizeTypes[0]?.value);
  const [winners, setWinners] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [offsetWinner, setOffsetWinner] = useState(0);
  const [searchCodeWinner, setSearchCodeWinner] = useState("");

  const TAKE = 10;
  const PAGE_SIZE = 10;

  useEffect(() => {
    prizeTypeSpecialRef.current = prizeTypeSpecial;
  }, [prizeTypeSpecial]);

  useEffect(() => {
    prizeTypeSecondlRef.current = prizeTypeSecond;
  }, [prizeTypeSecond]);

  useEffect(() => {
    searchCodeSpecialRef.current = searchCodeSpecial;
  }, [searchCodeSpecial]);

  useEffect(() => {
    searchCodeSecondRef.current = searchCodeSecond;
  }, [searchCodeSecond]);

  useEffect(() => {
    getRemainingPrize();
    getListWinnerByType(1, PAGE_SIZE, prizeTypeSelected, '');
    // getListWinner();
    setModalVideo(true);
    // document.body.classList.add("modal-open");
  }, []);



  const getRemainingPrize = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_REMAINING_PRIZE.request(
        null,
        (res) => {
          setRemaining(res);
          setIsLoading(false);
        },
        (err) => {
          setIsLoading(false);
        }
      )
    );
  };

  const getListWinner = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_LIST_WINNER_BY_TYPE.request(
        null,
        (res) => {
          if (res?.length) {
            const listSpecial = res?.find((elm) => elm?.prize === "SPECIAL");

            setListWinnerSpeciaSwiper(listSpecial?.winners || []);
            const listSecond = res?.find((elm) => elm?.prize === "SECOND");

            const listThree = res?.find((elm) => elm?.prize === "THREE");

            // const listPhaseSpecial = listSpecial?.winners?.reduce(
            //   (currentArr, currentObj) => {
            //     if (
            //       currentArr?.findIndex((elm) => elm === currentObj?.phaseId) <
            //       0
            //     ) {
            //       currentArr.push(currentObj?.phaseId);
            //     }
            //     return currentArr;
            //   },
            //   [0]
            // );

            // const listPhaseSecond = listSecond?.winners?.reduce(
            //   (currentArr, currentObj) => {
            //     if (
            //       currentArr?.findIndex((elm) => elm === currentObj?.phaseId) <
            //       0
            //     ) {
            //       currentArr.push(currentObj?.phaseId);
            //     }
            //     return currentArr;
            //   },
            //   [0]
            // );
            setPagesSpecial(Math.ceil(listSpecial?.winners?.length / TAKE));
            setPagesSecond(Math.ceil(listSecond?.winners?.length / TAKE));
            setPagesThree(Math.ceil(listThree?.winners?.length / TAKE));

            listWinnerSpecialOrigin.current = listSpecial?.winners || [];
            listWinnerSecondOrigin.current = listSecond?.winners || [];
            listWinnerThreeOrigin.current = listThree?.winners || [];


            // setListPhaseSecond(listPhaseSecond);
            // setListPhaseSpecial(listPhaseSpecial);
            setListWinnerSpecial(
              listSpecial?.winners?.filter((elm, index) => index <= TAKE - 1) ||
              []
            );
            setListWinnerSecond(
              listSecond?.winners?.filter((elm, index) => index <= TAKE - 1) ||
              []
            );

            setListWinnerThree(
              listThree?.winners?.filter((elm, index) => index <= TAKE - 1) ||
              []
            );

          }
        },
        (err) => { }
      )
    );
  };

  const onSearchWinner = (searchCode) => {
    // setPrizeTypeSelected(prizeTypes[0].value);
    setSearchCodeWinner(searchCode);
    getListWinnerByType(1, PAGE_SIZE, prizeTypeSelected, searchCode);
  }

  const onChangePrizeTypeSelected = (type) => {
    // setSearchCodeSpecial("");
    // setSearchCodeWinner('');
    // setOffsetWinner(0);
    getListWinnerByType(1, PAGE_SIZE, type, searchCodeWinner);
  }
  const onclearSearch = () => {
    setSearchCodeWinner("");
    setSearchCodeSpecial("");

    getListWinnerByType(1, PAGE_SIZE, prizeTypeSelected, "");
  };
  const onChangePageWinner = (pageNumber) => {
    let searchCode = searchCodeWinner?.length > 0 ? searchCodeWinner : '';
    console.log(prizeTypeSelected);
    console.log(searchCode);
    getListWinnerByType(pageNumber + 1, PAGE_SIZE, prizeTypeSelected, searchCode);
  }

  const getListWinnerByType = (pageNumber, pageSize, prizeType, searchCodeTmp) => {
    // $("html, body").scrollTop($("#list-winners").offset().top);
    setIsLoading(true);
    let payload = {
      page: pageNumber,
      pageSize: pageSize,
      phoneNumber: searchCodeTmp,
    }

    if (prizeType !== '') {
      payload = {
        ...payload,
        rewardType: prizeType,
      }
    }

    dispatch(
      actions.GET_LIST_WINNER_BY_TYPE.request(
        payload,
        (res) => {
          setIsLoading(false);
          if (res?.data?.winners?.length > 0) {
            setWinners(res?.data?.winners);
            setTotalPage(res?.data?.totalPage);
          } else {
            setWinners([]);
          }
        },
        (err) => {
          setIsLoading(false);
        }
      )
    );
  };

  const onChangePage = (pageOffsetTmp) => {
    setPageOffset(pageOffsetTmp);
    // getListWinnerByType(pageOffsetTmp * TAKE, prizeType, searchCodeTemp);
  };

  const onChangePageSpecial = (pageOffsetTmp, prizeType = 0) => {
    setPageOffsetSpecial(pageOffsetTmp);
    let end = (pageOffsetTmp + 1) * TAKE - 1;
    let start = end - TAKE - 1;
    let masterData =
      listWinnerSpecialOrigin.current?.filter(
        (elm, index) => index >= start && index <= end
      ) || [];
    if (prizeType !== 0) {
      masterData =
        masterData?.filter((elm) => elm.phaseId === parseInt(prizeType)) || [];
    }

    if (searchCodeSpecialRef.current) {
      masterData = listWinnerSpecialOrigin.current;
      let txtSearchHash = sha256(searchCodeSpecialRef.current)?.toUpperCase();
      masterData = masterData?.filter(
        (elm) => elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash
      );
    }

    setListWinnerSpecial(masterData);
  };

  const onChangePageSecond = (pageOffsetTmp, prizeType = 0) => {
    setPageOffsetSecond(pageOffsetTmp);
    // setPageOffset(pageOffsetTmp);
    let end = (pageOffsetTmp + 1) * TAKE - 1;
    let start = end > 9 ? end - TAKE + 1 : 0;

    console.log("start >>>", start, end);
    let masterData =
      listWinnerSecondOrigin.current?.filter(
        (elm, index) => index >= start && index <= end
      ) || [];

    if (prizeType !== 0) {
      masterData =
        masterData?.filter((elm) => elm.phaseId === parseInt(prizeType)) || [];
    }

    if (searchCodeSecondRef.current) {
      masterData = listWinnerSecondOrigin.current;
      let txtSearchHash = sha256(searchCodeSecondRef.current)?.toUpperCase();
      masterData = masterData?.filter(
        (elm) => elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash
      );
    }
    setListWinnerSecond(masterData);
  };

  const onChangePrizeTypeSpecial = (prizeTypeTmp) => {
    setPrizeTypeSpecial(parseInt(prizeTypeTmp));
    // setSearchCodeSpecial("");
    if (parseInt(prizeTypeTmp) === 0) {
      onChangePageSpecial(0, 0);
      if (!searchCodeSpecialRef.current) {
        setPagesSpecial(
          Math.ceil(listWinnerSpecialOrigin.current?.length / TAKE)
        );
      } else {
        setPagesSpecial(1);
      }
      return;
    }
    setPageOffsetSpecial(0);
    let masterData =
      listWinnerSpecialOrigin.current?.filter(
        (elm) => elm.phaseId === parseInt(prizeTypeTmp)
      ) || [];
    if (searchCodeSpecialRef.current) {
      let txtSearchHash = sha256(searchCodeSpecialRef.current)?.toUpperCase();
      masterData = masterData?.filter(
        (elm) => elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash
      );
    }
    setPagesSpecial(Math.ceil(masterData?.length / TAKE));

    setListWinnerSpecial(masterData);
  };

  const onChangePrizeTypeSecond = (prizeTypeTmp) => {
    setPrizeTypeSecond(parseInt(prizeTypeTmp));
    // setSearchCodeSecond("");
    if (parseInt(prizeTypeTmp) === 0) {
      onChangePageSecond(0, 0);
      if (!searchCodeSecondRef.current) {
        setPagesSecond(
          Math.ceil(listWinnerSecondOrigin.current?.length / TAKE)
        );
      } else {
        setPagesSecond(1);
      }
      return;
    }
    setPageOffsetSecond(0);
    let masterData =
      listWinnerSecondOrigin.current?.filter(
        (elm) => elm.phaseId === parseInt(prizeTypeTmp)
      ) || [];

    if (searchCodeSecondRef.current) {
      let txtSearchHash = sha256(searchCodeSecondRef.current)?.toUpperCase();
      masterData = masterData?.filter(
        (elm) => elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash
      );
    }

    setPagesSecond(Math.ceil(masterData?.length / TAKE));
    setListWinnerSecond(masterData);
  };

  const onSearchCodeSecond = (searchStr) => {
    let txtSearchHash = sha256(searchStr)?.toUpperCase();
    let dataResult = [];

    if (searchStr?.trim()?.length === 0) {
      if (prizeTypeSecondlRef.current > 0) {
        dataResult = listWinnerSecondOrigin.current?.filter(
          (elm) => elm?.phaseId === prizeTypeSecondlRef.current
        );
      } else {
        dataResult = listWinnerSecondOrigin.current;
      }
      let end = 1 * TAKE - 1;
      let start = end > 9 ? end - TAKE + 1 : 0;
      setPagesSecond(Math.ceil(dataResult?.length / TAKE));

      dataResult =
        dataResult?.filter((elm, index) => index >= start && index <= end) ||
        [];
    } else {
      if (prizeTypeSecondlRef.current > 0) {
        dataResult = listWinnerSecondOrigin.current?.filter(
          (elm) =>
            (elm.phoneHashed === txtSearchHash ||
              elm.codeHashed === txtSearchHash) &&
            elm?.phaseId === prizeTypeSecondlRef.current
        );
      } else {
        dataResult = listWinnerSecondOrigin.current?.filter(
          (elm) =>
            elm.phoneHashed === txtSearchHash ||
            elm.codeHashed === txtSearchHash
        );
      }
      setPagesSecond(Math.ceil(dataResult?.length / TAKE));
    }

    setSearchCodeSecond(searchStr);
    setListWinnerSecond(dataResult);
  };

  const onSearchCodeSpecial = (searchStr) => {
    let txtSearchHash = sha256(searchStr)?.toUpperCase();
    let dataResult = [];

    if (searchStr?.trim()?.length === 0) {
      if (prizeTypeSpecialRef.current > 0) {
        dataResult = listWinnerSpecialOrigin.current?.filter(
          (elm) => elm?.phaseId === prizeTypeSpecialRef.current
        );
      } else {
        dataResult = listWinnerSpecialOrigin.current;
      }
      let end = 1 * TAKE - 1;
      let start = end > 9 ? end - TAKE + 1 : 0;
      setPagesSpecial(Math.ceil(dataResult?.length / TAKE));

      dataResult =
        dataResult?.filter((elm, index) => index >= start && index <= end) ||
        [];
    } else {
      if (prizeTypeSpecialRef.current > 0) {
        dataResult = listWinnerSpecialOrigin.current?.filter(
          (elm) =>
            (elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash) &&
            elm?.phaseId === prizeTypeSpecialRef.current
        );
      } else {
        dataResult = listWinnerSpecialOrigin.current?.filter(
          (elm) =>
            elm.phoneHashed === txtSearchHash || elm.code === txtSearchHash
        );
      }
      setPagesSpecial(Math.ceil(dataResult?.length / TAKE));
    }

    setSearchCodeSpecial(searchStr);
    setListWinnerSpecial(dataResult);
  };

  const isSearchPhone = useCallback(() => {
    if (searchCodeSpecial === "0" || !searchCodeSpecial) {
      return true;
    }
    if (
      searchCodeSpecial?.startsWith("0") &&
      parseInt(searchCodeSpecial) > 0
    ) {
      return true;
    }
    return false;
  }, [searchCodeSpecial]);

  const closeModalVideo = () => {
    setModalVideo(false);
    document.body.classList.remove("modal-open");
  };
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      {/* {modalVideo && <PopupVideo closeModalVideo={closeModalVideo} />} */}
      <PrizeView
        onChangePage={onChangePage}
        onChangePrizeTypeSpecial={onChangePrizeTypeSpecial}
        onChangePrizeTypeSecond={onChangePrizeTypeSecond}
        onSearchCodeSpecial={onSearchCodeSpecial}
        onSearchCodeSecond={onSearchCodeSecond}
        pageOffset={pageOffset}
        remaining={remaining}
        listWinnerSecond={listWinnerSecond}
        listWinnerSpecial={listWinnerSpecial}
        listWinnerThree={listWinnerThree}
        listPhaseSpecial={listPhaseSpecial}
        listPhaseSecond={listPhaseSecond}
        listPhaseThree={listPhaseThree}
        pagesSecond={pagesSecond}
        pagesSpecial={pagesSpecial}
        pagesThree={pagesThree}
        pages={pages}
        searchCode={searchCode}
        searchCodeTemp={searchCodeTemp}
        setSearchCode={setSearchCode}
        setSearchCodeSpecial={setSearchCodeSpecial}
        setSearchCodeSecond={setSearchCodeSecond}
        onChangePageSecond={onChangePageSecond}
        onChangePageSpecial={onChangePageSpecial}
        prizeTypeSecond={prizeTypeSecond}
        prizeTypeSpecial={prizeTypeSpecial}
        searchCodeSpecial={searchCodeSpecial}
        searchCodeSecond={searchCodeSecond}
        listWinnerSpeciaSwiper={listWinnerSpeciaSwiper}
        pageOffsetSecond={pageOffsetSecond}
        pageOffsetSpecial={pageOffsetSpecial}
        listPicture={listPicture}
        prizeTypes={prizeTypes}
        prizeTypeSelected={prizeTypeSelected}
        setPrizeTypeSelected={setPrizeTypeSelected}
        winners={winners}
        onSearchWinner={onSearchWinner}
        onChangePrizeTypeSelected={onChangePrizeTypeSelected}
        totalPage={totalPage}
        onChangePageWinner={onChangePageWinner}
        offsetWinner={offsetWinner}
        setOffsetWinner={setOffsetWinner}
        isSearchPhone={isSearchPhone}
        onclearSearch={onclearSearch}
      />
    </>
  );
};

export default PrizePage;
